<script setup>
import { useAuth } from '../auth.js';
import { useSetups } from '../setups.js';

const { isLoggedIn } = useAuth();
const { setups, activeSetupId, selectSetup } = useSetups();
</script>

<template>
  <div v-if="isLoggedIn" class="setup-select-group">
    <select
      class="setup-select"
      title="Active setup"
      :value="activeSetupId"
      @change="selectSetup($event.target.value)"
    >
      <option v-for="s in setups" :key="s.id" :value="s.id">{{ s.name }}</option>
    </select>
  </div>
</template>

<style scoped>

.setup-select-group {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

/* The one solidly-colored element in the top bar — which setup you're
   actively editing is the thing most worth noticing at a glance, so it
   gets the accent color the account trigger/undo/redo used to all share
   (see account_widget.vue and app.vue's .undo-redo), rather than
   everything competing for the same attention. */
.setup-select {
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--border-radius);
  border: none;
  background: var(--color-accent);
  color: var(--color-text-light);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  cursor: pointer;
  max-width: 40vw;
}

/* 40vw made sense as an inline element sharing a row with other bar
   content — inside account_widget.vue's collapsed phone menu (see its
   .mobile-popover-setup), this sits stretched full-width in its own row
   instead, where a 40vw cap would just leave it oddly narrow. */
@media (max-width: 700px) {
  .setup-select {
    max-width: 100%;
    width: 100%;
  }
}

</style>
